export default "__VITE_ASSET__bb113343__"